import { applyAttributesFilter } from '@process-advisor/process-miner/api/methods/filters/applyAttributesFilter';
import { applyVariantFilter } from '@process-advisor/process-miner/api/methods/filters/applyVariantFilter';
import { applyStepFilter } from '@process-advisor/process-miner/api/methods/filters/applyStepFilter';
//import { applyMetricFilter } from '@process-advisor/process-miner/api/methods/filters/applyMetricFilter';
import { applyActivityFilter } from '@process-advisor/process-miner/api/methods/filters/applyActivityFilter';
import { applyTimeFilter } from '@process-advisor/process-miner/api/methods/filters/applyTimeFilter';
import { applyPathFilter } from '@process-advisor/process-miner/api/methods/filters/applyPathFilter';
import { resetAttributesFilterDefaults } from '@process-advisor/process-miner/api/methods/filters/resetAttributesFilterDefaults';
import { resetTimeFilterDefaults } from '@process-advisor/process-miner/api/methods/filters/resetTimeFilterDefaults';
import { SetAttributeFilterData as setAttributeFilter } from '@process-advisor/process-miner/api/methods/filters/setAttributesFilter';
import { processAttributesTable } from '@process-advisor/process-miner/api/methods/filters/processAttributesTable';
import { defaultMinMaxTime } from '@process-advisor/process-miner/api/methods/filters/defaultMinMaxtime';
import { updateVariantFilterLoops } from '@process-advisor/process-miner/api/methods/filters/updateVariantFilterLoops';
import { taskEventAttributes } from '@process-advisor/process-miner/api/methods/filters/taskEventAttributes';
import { metrics } from '@process-advisor/process-miner/api/methods/filters/metrics';
import { setFilterDeleteRow } from '@process-advisor/process-miner/api/methods/filters/filterDeleteRow'
import { deleteFilter } from '@process-advisor/process-miner/api/methods/filters/deleteFilter'
import { applyFilterEvents } from '@process-advisor/process-miner/api/methods/filters/applyFilterEvents'
import { saveTaskAttributeFilterGridState} from '@process-advisor/process-miner/api/methods/filters/saveTaskAttributeGridState'
import { saveEventAttributeFilterGridState} from '@process-advisor/process-miner/api/methods/filters/saveEventAttributeGridState'
import { changeStepSelectRetention } from '@process-advisor/process-miner/api/methods/filters/changeStepSelectRetention';
import { changeStepSelectOperator } from '@process-advisor/process-miner/api/methods/filters/changeStepSelectOperator';
import { changeActivitySelectRetention } from '@process-advisor/process-miner/api/methods/filters/changeActivitySelectRetention';
import { changeActivitySelectOperator } from '@process-advisor/process-miner/api/methods/filters/changeActivitySelectOperator';
import { changePathSelectRetention } from '@process-advisor/process-miner/api/methods/filters/changePathSelectRetention';
import { changePathSelectOperator } from '@process-advisor/process-miner/api/methods/filters/changePathSelectOperator';
import { changeIncludeStart } from '@process-advisor/process-miner/api/methods/filters/changeIncludeStart';
import { setStepFilterSelectedData } from '@process-advisor/process-miner/api/methods/filters/setStepFilterSelectedGridData';
import { setVariantFilterSelectedData } from '@process-advisor/process-miner/api/methods/filters/setVariantFilterSelectedGridData';
import { setPathFilterSelectedData } from '@process-advisor/process-miner/api/methods/filters/setPathFilterSelectedGridData';
import { setActivityFilterSelectedData } from '@process-advisor/process-miner/api/methods/filters/setActivityFilterSelectedGridData';
import { changeSelectAction, getSelectAction } from '@process-advisor/process-miner/api/methods/filters/changeSelectAction';
import { setActivityDetailProps} from '@process-advisor/process-miner/api/methods/filters/setActivityDetailProps'
import { setStepDetailProps} from '@process-advisor/process-miner/api/methods/filters/setStepDetailProps'
import { saveStepFilterGridState } from '@process-advisor/process-miner/api/methods/filters/saveStepGridState'
import { saveVariantFilterGridState } from '@process-advisor/process-miner/api/methods/filters/saveVariantGridState'
import { saveActivityFilterGridState } from '@process-advisor/process-miner/api/methods/filters/saveActivityGridState'
import { saveActivityTypeFilterGridState } from '@process-advisor/process-miner/api/methods/filters/saveActivityTypeGridState'
import { generateTasksFilteredArray } from '@process-advisor/process-miner/api/methods/filters/generateTasksFilteredArray';
import { filterConditions } from '@process-advisor/process-miner/api/methods/filters/filterConditions';
import {applyDiscovery} from '@process-advisor/process-miner/api/methods/filters/applyDiscovery'
import { applySimilarVariantFilter} from '@process-advisor/process-miner/api/methods/filters/applySimilarVariantFilter'
import { applyWorkflowFilter } from '@process-advisor/process-miner/api/methods/filters/applyWorkflowFilter';

export const filtersMethods = {
    applyAttributesFilter,
    applyTimeFilter,
    resetAttributesFilterDefaults,
    resetTimeFilterDefaults,
    setAttributeFilter,
    processAttributesTable,
    defaultMinMaxTime,
    updateVariantFilterLoops,
    taskEventAttributes,
    metrics,
    //applyMetricFilter,
    setFilterDeleteRow,
    deleteFilter,
    applyFilterEvents,
    saveTaskAttributeFilterGridState,
    saveEventAttributeFilterGridState,
    changeStepSelectRetention,
    changeActivitySelectRetention,
    changeStepSelectOperator,
    changeActivitySelectOperator,
    changePathSelectRetention,
    changePathSelectOperator,
    changeIncludeStart,    
    setStepFilterSelectedData,
    setPathFilterSelectedData,
    setActivityFilterSelectedData,
    saveStepFilterGridState,
    saveVariantFilterGridState,
    saveActivityFilterGridState,
    saveActivityTypeFilterGridState,
    changeSelectAction,
    getSelectAction,
    setStepDetailProps,
    setActivityDetailProps,
    applyStepFilter,
    applyActivityFilter ,
    applyPathFilter ,
    generateTasksFilteredArray,
    filterConditions,
    applyDiscovery,
    applySimilarVariantFilter,
    applyWorkflowFilter,
    setVariantFilterSelectedData,
    applyVariantFilter
};

